import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import InfoBlock from 'ah-common-lib/src/common/components/InfoBlock.vue';
import { OnboardingIndividualInfo } from 'ah-api-gateways';
import { formatDate } from 'ah-common-lib/src/helpers/time';
import { countryNameFromCC } from 'ah-common-lib/src/helpers/countries';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientMemberInfoBlock',
  props: {
  member: {
    type: Object as PropType<OnboardingIndividualInfo>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const userBlock = [
  { label: 'Title', key: 'title', cols: 4 },
  { label: 'Name', key: 'firstName', cols: 4 },
  { label: 'Surname', key: 'lastName', cols: 4 },
  { label: 'Email Address', key: 'email', cols: 4 },
  { label: 'Mobile Number', key: 'phoneNumber', cols: 4 },
  { label: 'Date of Birth', key: 'birthDate', cols: 4 },
  { label: 'Requested Permissions', key: 'permissions', cols: 4 },
];

function addressHistoryBlock(isOwnerFromUK: boolean) {
  return [
    { label: 'Address Line 1', key: 'addressLine', cols: 4 },
    { label: 'City', key: 'city', cols: 4 },
    { label: 'State/Province/County', key: 'stateOrProvince', cols: 4 },
    { label: 'Postcode/Zip Code', key: 'postalCode', cols: 4 },
    { label: 'Country', key: 'countryCode', cols: 4 },
    ...(isOwnerFromUK
      ? [
          {
            label: 'When did the Signatory move to this address?',
            key: 'residingFrom',
            cols: 8,
          },
        ]
      : []),
  ];
}

const isMemberAUkResident = computed(() => props.member.currentAddress?.countryCode === 'GB');

return { __sfc: true,props, userBlock, addressHistoryBlock, isMemberAUkResident, InfoBlock, formatDate, countryNameFromCC }
}

})